import type { GetStatisticsResponseDto } from 'shared/dtos/statistics.dto';

import { ApiService } from './api.service';

export default class StatisticsService extends ApiService {
  public getStatistics = async (): Promise<GetStatisticsResponseDto> => {
    return await this.get(`/general/counts`);
  };
}
